import { LitElement, css, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'

/**
 * A nav list
 */
@customElement('ep-nav-list-divider')
export class EPNavListDivider extends LitElement {

  @property({ type: Boolean, reflect: true })
  inset: boolean = false

  render() {
    return html`
      <li></li>
    `
  }

  static styles = css`
    :host {
      --font-prose: ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
      --color-soft-black: rgb(36, 41, 47);
    }

    :host([inset]) li {
      margin-left: 72px;
    }

    * {
      box-sizing: border-box;
    }

    li {
      height: 1px;
      background-color: rgba(208, 215, 222, 0.48);
      margin-top: calc(7px);
      margin-bottom: 8px;
      list-style: none;
    }
  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-nav-list-divider': EPNavListDivider
  }
}
